export default class Events {
  client

  constructor(client) {
    this.client = client
  }

  groupList(params, options = {}) {
    return this.client.post("/api/v2/events/group_list", params, options)
  }
}
